(function () {
    'use strict';

    if (document.querySelector(".org-highlight-block .ambient")) {
        gsap.registerPlugin(ScrollTrigger);
        
        gsap.to('.org-highlight-block .ambient', {
            y: '-25%',
            scrollTrigger: {
                trigger: '.org-highlight-block', // Element that triggers the animation
                toggleActions: 'restart pause reverse pause',
                start: 'top 50%', // When the top of the trigger hits 80% of the viewport
                end: 'bottom 50%', // End point of the animation
                scrub: 1, // Smooth scrubbing effect as you scroll
            },
        });
    }
})();
